'use client';

import ErrorPage from './errorPage';

const NotFound = () => {
  return (
    <ErrorPage
      errorCode={404}
      errorMessage='We couldn&#39;t find the page you are looking for.'
      title='Page Not Found'
    />
  );
};

export default NotFound;
